// ABOUTME: Display-mode selector for the pivot table — normal / period-over-period / compare-previous / compare.
// ABOUTME: Icon toggle group shown in the pivot header (top-right), persisting on currentReport.pivot.mode.
import { ToggleButton, ToggleButtonGroup, Tooltip, useTheme } from "@mui/material";
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import CompareArrowsOutlinedIcon from "@mui/icons-material/CompareArrowsOutlined";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../theme";
import { pivotViewModes } from "../../reportUtils";

const MODES = [
    { value: pivotViewModes.NORMAL, labelKey: "pivot_mode_normal", Icon: TableRowsOutlinedIcon },
    { value: pivotViewModes.PERIOD_OVER_PERIOD, labelKey: "pivot_mode_period", Icon: TrendingUpOutlinedIcon },
    { value: pivotViewModes.COMPARE_PREVIOUS, labelKey: "pivot_mode_compare_previous", Icon: HistoryOutlinedIcon },
    { value: pivotViewModes.COMPARE, labelKey: "pivot_mode_compare", Icon: CompareArrowsOutlinedIcon },
];

export const RhPivotModeToggle = ({ mode, onChange, sx }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isDark = theme.palette.mode === "dark";
    const accent = isDark ? colors.blue : colors.primary;

    return (
        <ToggleButtonGroup
            exclusive
            value={mode}
            onChange={(e, v) => v !== null && onChange(v)}
            sx={{
                padding: 0.5,
                borderRadius: 5,
                background: isDark ? colors.grey[200] : colors.grey[0],
                height: 40,
                flexShrink: 0,
                gap:1,
                ...sx?.main,
            }}
        >
            {MODES.map(({ value, labelKey, Icon }) => (
                <Tooltip
                    key={value}
                    title={t(labelKey)}
                    arrow
                    slotProps={{
                        tooltip: {
                            sx: {
                                background: isDark ? colors.grey[600] : colors.grey[400],
                                borderRadius:4,
                                px:1.5,
                                fontSize:11,
                            },
                        },
                        arrow: {
                            sx: { color: isDark ? colors.grey[600] : colors.grey[400] },
                        },
                    }}
                >
                    <ToggleButton
                        value={value}
                        aria-label={t(labelKey)}
                        sx={{
                            border: 0,
                            borderRadius: "16px !important",
                            height: 32,
                            width:32,
                            color: colors.txt["primary"],
                            display:'flex',
                            alignItems:'center',
                            justifyContent:'center',
                            transition: "250ms",
                            "&.Mui-selected": {
                                background: accent[100],
                                color: accent[400],
                                "&:hover": { background: accent[100] },
                            },
                        }}
                    >
                        <Icon fontSize="small" />
                    </ToggleButton>
                </Tooltip>
            ))}
        </ToggleButtonGroup>
    );
};
